// src/pages/Home.js
import React from "react";

export default function Home() {
  return (
    <section>
      <h2 className="text-3xl font-bold mb-4">
        ¡Bienvenido a la Tienda Deportiva!
      </h2>
      <p className="mb-6">
        Explora nuestros productos oficiales de los mejores equipos de fútbol de
        Europa.
      </p>

      <div className="aspect-w-16 aspect-h-9 mb-6">
        <iframe
          src="https://www.youtube.com/watch?v=nhUYBR7Kgao"
          title="Video Tienda Deportiva"
          frameBorder="0"
          allowFullScreen
          className="w-full h-full"
        ></iframe>
      </div>

      <div className="aspect-w-16 aspect-h-9">
        <iframe
          src="https://www.google.com/maps/embed?..."
          title="Ubicación Tienda Deportiva"
          frameBorder="0"
          allowFullScreen
          className="w-full h-full"
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
}
